module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-game",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "game-titles"
  }, [_c('h6', [_vm._v("\n      " + _vm._s(_vm.currentData && _vm.currentData.courseName) + "\n      " + _vm._s(_vm.externalData ? _vm.externalData.name : _vm.$t("grammarGame.game-header.title")) + "\n    ")]), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.currentData ? _vm.currentData.name : _vm.$t("grammarGame.game-header.title")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-155a5166","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GrammarGame/game-header.vue
// module id = 425
// module chunks = 1 3